module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header-wrapper"
  }, [_c('div', {
    staticClass: "page-header page-header-default"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "mat"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dc1fbf0c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/crumbs.vue
// module id = 1140
// module chunks = 1